import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import translationEn from "./locales/en/translation.json";
import translationPt from "./locales/pt/translation.json";
import translationCh from "./locales/ch/translation.json";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    lng: "pt",
    fallbackLng: "pt",

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      pt: {
        translations: translationPt,
      },
      ch: {
        translations: translationCh,
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;
